import { ActiveTrial, AloftDate } from '@aloft/toolkit-shared';

import pluralize from 'pluralize';

export function getTrialEndMessage(subscription: ActiveTrial): string {
  const daysUntilTrialEnd = subscription.trialEnd.differenceInCalendarDays(AloftDate.today());

  return `Your free trial ends in ${daysUntilTrialEnd.toLocaleString()} ${pluralize(
    'day',
    daysUntilTrialEnd,
  )}.`;
}
